import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AddIcon from "@mui/icons-material/Add";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventIcon from "@mui/icons-material/Event";
import PercentIcon from "@mui/icons-material/Percent";
import DiscountIcon from "@mui/icons-material/Discount";
import MyTimeLogo from "../../images/mytime-logo.png";
import LockOutlineIcon from "@mui/icons-material/LockOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BadgeIcon from "@mui/icons-material/Badge";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export const TimeIcon = ({ fontSize = "small", color = "#319fb5" }) => (
  <AccessTimeIcon sx={{ fontSize: fontSize, color: color }} />
);

export const StaffIcon = ({ fontSize = "medium", color = "#319fb5" }) => (
  <BadgeIcon sx={{ fontSize: fontSize, color: color }} />
);

export const ErrorIcon = ({ className = "" }) => (
  <div
    className={`mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10 ${className}`}
  >
    <ErrorOutlineIcon className="h-6 w-6 text-red-600" />
  </div>
);

export const ConfirmationIcon = ({ className = "" }) => (
  <div
    className={`mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10 ${className}`}
  >
    <CheckCircleOutlineIcon className="h-6 w-6 text-green-600" />
  </div>
);

export const InfoIcon = ({ className = "" }) => (
  <div
    className={`mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-primary-50 sm:mx-0 sm:h-10 sm:w-10 ${className}`}
  >
    <InfoOutlinedIcon className="h-6 w-6 text-primary" />
  </div>
);

export { CloseIcon };

export const CouponIcon = ({ size = 15 }) => (
  <LocalOfferOutlinedIcon sx={{ fontSize: size }} />
);

export const PromotionIcon = ({ size = 15 }) => (
  <PercentIcon sx={{ fontSize: size }} />
);

export const PlusIcon = ({ className = "h-4 w-4 mr-1" }) => (
  <AddIcon className={className} />
);

export const UserIcon = ({ className }) => (
  <div
    className={`relative inline-flex items-center justify-center ${className}`}
  >
    <div className="absolute inset-0 bg-primary rounded-full"></div>
    <PersonOutlineIcon
      className="relative h-0.5 w-0.5 text-white"
      sx={{ fontSize: 22 }}
    />
  </div>
);

export const SectionIcon = ({ icon: Icon, className = "" }) => (
  <div
    className={`flex items-center justify-center w-6 h-6  mt-0.5 rounded-md bg-primary-50 text-primary ${className}`}
  >
    <Icon className="w-2 h-2" sx={{ fontSize: 18 }} />
  </div>
);

export const AppointmentIcon = ({ className = "" }) => (
  <SectionIcon icon={EventIcon} className={className} />
);

export const ClassesIcon = ({ className = "" }) => (
  <SectionIcon icon={PeopleAltIcon} className={className} />
);

export const MembershipIcon = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center w-6 h-6 mt-0.5 rounded-md bg-primary-50 text-primary ${className}`}
  >
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAt9JREFUSA3FVUtIlFEUPuf+M5pRBFNZFFFYC6HVzCgW9CJQzGm0VdCm8EW5iqhcmosetIweRo4TFK2KaPx7kIsgoiRMXVWIQSQtjLDC1B7Of0/nTnPjd8b/YSDezXl955xvzr3nH4AFPui3f/S6WSolVQqiYiD4Jgyjt69h7wu/+U44TwLtRKK7y7xCRIdziyDgkyIR2ve8cdt3HYskUtWsn9W2oyQ4PdBcdzfgCMgGuPnR2ZqrMAHtnpJjl1g9lIUDgghJkmFtO0kmv0LFPAlwm2NORZSfR3igojPV+rK57lMGtwruia9ivVuOii1dtOSLkq4Eoqa5WI7KdQrodAggKA1jI8czBPrj8SnWR5zwuX5XAkXjWDiZmzGLLQkKtXt78uHKSZSl2tbSABzuq4+NaltLVwJWMPQT4LPGOkoJxLi/Z0palUTylra1TAvRwvpVbWvpSuB3SUEaBjXUWQYEpXVUgvjI7yalbS0R8b3W7dJzDcOJ7jEgCtmT8nQMbBhsin3I8/twCE8MwTM3DK/TyP82V3Vdr0AB0BAdZFl1Sp/tMIEOu7+s09xlIbXafXYdCYYGmmv/rbYngf76WE8kYb7me91sL5TVJwoweM3uJ4Q1fGV77D67TojL7bYnAX48FO0yj/D/wFNOnHllQpzsbazOfFB0USNY9Binf1RoO1cawpiw+zwfYXnyfkmaqAqJTvEnebVO5sRpRGCf0dPfFBtQRHVsLtKRAI89zg2P8+h3ehVkIkPc/kLx2mDyUU3NLy+8PZ5HIJx4sAPJOs9/NFvsQD+62ggeRFu8sfZmO6L0l5NFRZNmhCSd419d5SfRDcPX8VYIbHvVEL/jhlOxzASinakWfr0XicDwSphj/MamZbUNt/ej5ZQnwl3mVol4eR6aq54H342bJ5yaKz+vFZXx3ua9BbekucS4cLkbfuZeuyHnKRZAAX1AeMZvfeRxSRS+d56H+8Zv7QXB/QHU+uqQkW89KAAAAABJRU5ErkJggg=="
      alt="Gift Card"
      className="w-4 h-3"
    />
  </div>
);

export const ProductIcon = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center w-6 h-6 mt-0.5 rounded-md bg-primary-50 text-primary ${className}`}
  >
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAB5UlEQVRIie3XPWsUURTG8d8m0UYt4luRRhEr0SaKRKtI3moLC7/AbZSplVsPFnYDCs6XsLIw2dWACAHBFEKwCYhIQNSkUEQhiRYzy042Zl/EYLMHbjMz53n+58693HNr+ow0y8cwg2nMYgsLqGM+JuFjP3q1HgwPYbJieK5LypsSaB4vYhK+9wWQZvkwLiqqnMUVHOgGukf8xMsSaAHLMQnbuwDSLD+jqHAO1zD6l4bd4gsaitlZiEl4X0uz/CYCruLgPhm3xw/FzDwcwuOYhGbVc7iPZfz6h4bbeIV7mMJoTMI0ngxhPc3yedzCJ9yJSRjHCdzAI6z+helbPMB1HItJuIyIddxOs/wpNmpplrdX+hnPlFsrJuEdpFl+uqRvjpNteWuK/9tAIybhQ5l3SrG+muN4NelPAO2xqrXPn8ckrKdZXsOFEmSzNFwpDY8qFvKUYied7STeC0A1tvG6ArRYPp9UVDeDcQz1KjjSh7lS+FI57mpt10afOjsE/2sMAAYAA4ABwABgADCC81rNwiQO77PnN8UxXkd9R1ueZvkIJipAExjuINY8jjc6fLOFpaYhlmISNpsvO15M0iw/otVsTNt9KdkLYKViuBiT8HUvj643ozagMTv7uyZQ1bAek7DWq+ZvsZSNCu1LxjEAAAAASUVORK5CYII="
      alt="Gift Card"
      className="w-4 h-3"
      style={{
        filter:
          "invert(43%) sepia(71%) saturate(502%) hue-rotate(138deg) brightness(95%) contrast(92%)",
      }}
    />
  </div>
);

export const PackageIcon = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center w-6 h-6 mt-0.5 rounded-md bg-primary-50 text-primary ${className}`}
  >
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAB6klEQVR4Ab3WQ9QbARRA4dq2bWtZ27Zt29autm23m9q2bdtu338XbzHBID7nSzK84ySSv69CS3aNgjh0MZBQXgzDDwicWopS/gS3QtR7bLVx1RgOJPgHtRzMnw5PHAeZKQZqoI5bsC6iYhnExB0kRWK8Mg3qiipiEd5DMNUtWBpNITYO6XIPIcZIFJTAHLyGGJkEWzu6Qt2DfCmF5xAvnmMa8gQzOAxi8BpzUQpRkBB5gxLkrT2+Q3AGlREV8dAYO/ALU4MVvAlRzZAM69xv7GAGx0FwFlExCqJCEsxruDiiYHtIgzpwBYISaBGO4AgIZiEBfoQ6mAuC14iKTSEN6ohzEJRD43AEB0MwD/HwNdTBrIbfuOhYG9KgjjwJQWXUC0ewHwSLERufIQH+PB2xCmaA4BNiYoVFsB6iYKHND3AKJDL9AWbkUQhqKLPgH9R38I8hjeVfDEb2gGAFYuKjt6D6EPCfKN2i//iK2FgEwXqdnh29DD9pTs1GUbPDcMBwnipD8BftkUznGQJx6Kzdce8MwVpExyOI+ohikYL50ivrH74hnkY7oAZiqooo7UUyf6N7ILiG/oiFKliBTxAvTqKQv8F2EIOfJpFLGIysgR7WJPiOb14iNzEKuYJ9LqMhCvrjHiajQCDrjAAvEbGWkZm1OwAAAABJRU5ErkJggg=="
      alt="Gift Card"
      className="w-4 h-4"
    />
  </div>
);

export const GiftCardIcon = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center w-6 h-6 mt-0.5 rounded-md bg-primary-50 text-primary ${className}`}
  >
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACQklEQVR4Ae3XQ7AccRDH8d0X27Zt2zbOOcd8xiXc5BLbtm3btm0bne+ht6prnnXbf9XnoXvwG8+4YhtV529Ni3DcheAVZqKAK7kHK/HDbogT3qNhcgfoAlHT0AaBeGdCFHPMkxFDsQarMASZEhogAoILjnpJE2KnqVfCI4iltUIJCdALgq/I6uj1hKiWyIcXEPzCCqzCTwiWOOYvBb/YAmTDFwhmRdE/CsEurIHgM+qZaQZC8MbUOuEzBsVlLwRCVH9HrxvEoY9jmu7eYKa2AIL7zpWlRBW0RVc0Q1nsgqggx/SvIOoy/Ew/NQ5AcNTUO0Ag3kImePABAqe/EGMxsqIJLkKUBynhRntcgqjuuq4auArBFe9lcxZi/MEnSAz+RVP/gPsQYxkG4ABE/UJzFz8mma30oIzZVVnhj8eQJHQFdb0r2YW/iND/SyMQ+8wlFO1hSYA38Ecxe/LlQgZz72+BcThndvU/nMVoNEMatMU5iPqBBziJ1ViMx2b+0xiFJkgd3WUXgmGobMK1QU5zwnbGZNyEGL9wCBGoDbfOUxY54EZl+CMkugAbIOoZFqKq6ZfBEGzDN4jxGZswAKUdt+6FeA5RG2ILYA3W3iJzCFIjDZrDH42RCqm1PwYbdL6uECBxAS5A1BdsRhvt9dD/v0LUg+QKYE1wzucL4AvgC+AL4AuQ2AAj8TWZA3zBCFd0wzzRPDiHgYkM0BnnMAbNkDreH6n6eyyexzHAc0x0JfUwbzUB2A2P1lfo//7ad7viMP4DdLBBjfCsrvYAAAAASUVORK5CYII="
      alt="Gift Card"
      className="w-4 h-4"
    />
  </div>
);

export const DiscountsIcon = ({ className = "" }) => (
  <SectionIcon icon={DiscountIcon} className={className} />
);

export const MyTimeLogoIcon = () => (
  <div className="mytime-logo mx-auto">
    <div className="text-[#60b0c2] text-[6px] ml-[38px] -mb-[11px] font-sans">
      Powered by
    </div>
    <img src={MyTimeLogo} alt="MyTime Logo" className="w-20" />
  </div>
);

export const LockerIcon = () => {
  return <LockOutlineIcon fontSize="small" sx={{ fontSize: 15 }} />;
};

export const SurchargeIcon = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center w-6 h-6 mt-0.5 rounded-md bg-primary-50 text-primary ${className}`}
  >
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGeSURBVEiJrdXBq41BGMfxz3Mv6VggdbO0Ex1FpGSlZMvJSqysyMJKylL5E2SlbOzs7sLuFsUtq1tWxK3LRrIQSifqjsWZ03kd77zmnuOpp+add57ft3memWcipaTWIuIhDqWUTlbHbBGwgf3opZSGNTELlcLbI+IEduapfkRUxUopFR378AhDpCn/imX0OzU6xI/hS4vwtP/CnS0BsAvrDZFlDPA2f1/Fy8b/n0Z1qQZcaASvNOZf57k9+fsUHuBKaQfbCqU53hjf76jfKlaLBVY+RZ8a46NdAv+0jgKPU7SJxziDNxopqvGuU3RP+eRcxOK8gAXcxocC5H3+vzQToAFaxDk8yemaBg1xfmbAFGwjiz6dgv3AkbaYun7ytw3QzyDo4VLryhl3ML5oS42dvPifOxjb0KhNQLQtaAVExI2I+BwRdyOi1wG4jB15/Kp1RSEVz0wKuI6bOGySogO4ju8mza61bZcAB/Fc+aI1fRO3ZrlogWt41yG8htNzXbQM24uz+JjFB9g9V6sogP54D2q89B6UbMXoLf5WG/AbL64Hl4AwHNwAAAAASUVORK5CYII="
      alt="Surcharge Icon"
      className="w-3 h-3"
      style={{
        filter:
          "invert(43%) sepia(71%) saturate(502%) hue-rotate(138deg) brightness(95%) contrast(92%)",
      }}
    />
  </div>
);

export const CancellationFeesIcon = () => <SectionIcon icon={CancelIcon} />;

export const MiscItemIcon = ({ className = "" }) => (
  <SectionIcon icon={ReceiptLongIcon} className={className} />
);
